export const mockCandidate = [
    {
        candidate_mob_no: '8958452658',
        candidate_name: 'Nishit',
        cv_link: 'https://drive.google.com/file/d/1MlDuj1lxHkbnz5EOxRvLCYovNF6g97Sj/view',
        email: 'Nishmhatre09@gmail.com',
        feedback: 'Good',
        feedback_by: '5174',
        hiring_location: 'India',
        id: 1,
        interview_scheduled_at: null,
        interview_status: 'Pending',
        intro_video: 0,
        intro_video_2: 0,
        is_shortlisted: 'yes',
        job_title: 'DevOps Engineer',
        joining_date: 'Sun, 15 Sep 2024 00:00:00 GMT',
        offer_sent: 'Pending',
        offer_status: 'accepted',
        onboard_email: null,
        panelist_id: '5174',
        panelist_status: 'selected',
        quantanite_email: null,
        recruiter_status: 'Accepted',
        recruiter_status_updated_by: '5174',
        reminder_count: 0,
        reminder_sent_at: null,
        sent_at: null,
        status: 'Accepted',
    },
    {
        candidate_mob_no: '9854712565',
        candidate_name: 'Mahesh',
        cv_link: 'https://drive.google.com/file/d/1gqUFJQ7W4tONFO1zY2xtaFqwPfWQfaMP/view',
        email: 'maheshajadhav27@gmail.com',
        feedback: null,
        feedback_by: null,
        hiring_location: 'India',
        id: 2,
        interview_scheduled_at: null,
        interview_status: 'Pending',
        intro_video: 0,
        intro_video_2: 0,
        is_shortlisted: 'yes',
        job_title: 'DevOps Engineer',
        joining_date: null,
        offer_sent: 'Pending',
        offer_status: 'pending',
        onboard_email: null,
        panelist_id: '5174',
        panelist_status: null,
        quantanite_email: null,
        recruiter_status: null,
        recruiter_status_updated_by: null,
        reminder_count: 0,
        reminder_sent_at: null,
        sent_at: null,
        status: 'Pending',
    },
    {
        candidate_mob_no: '9854875695',
        candidate_name: 'Suhani',
        cv_link: 'https://drive.google.com/file/d/1WvuhrGbhTXJHaGFCdYbfr9dlsbKfLJz9/view',
        email: 'suhaniagarwal0330@1gmail.com',
        feedback: null,
        feedback_by: null,
        hiring_location: 'India',
        id: 3,
        interview_scheduled_at: null,
        interview_status: 'Pending',
        intro_video: 0,
        intro_video_2: 0,
        is_shortlisted: 'yes',
        job_title: 'AI Engineer',
        joining_date: null,
        offer_sent: 'Pending',
        offer_status: 'pending',
        onboard_email: null,
        panelist_id: null,
        panelist_status: null,
        quantanite_email: null,
        recruiter_status: null,
        recruiter_status_updated_by: null,
        reminder_count: 0,
        reminder_sent_at: null,
        sent_at: null,
        status: 'Rejected',
    },
    {
        candidate_mob_no: '9854758965',
        candidate_name: 'Nikhil',
        cv_link: 'https://drive.google.com/file/d/1ylx41Nr8kfeOMO4yRnpcgQRxArVnSN36/view',
        email: 'nikhilj0911@gmail.com',
        feedback: null,
        feedback_by: null,
        hiring_location: 'India',
        id: 4,
        interview_scheduled_at: 'Sat, 23 Nov 2024 13:00:00 GMT',
        interview_status: 'Pending',
        intro_video: 0,
        intro_video_2: 0,
        is_shortlisted: null,
        job_title: 'DevOps Engineer',
        joining_date: null,
        offer_sent: 'Pending',
        offer_status: 'pending',
        onboard_email: null,
        panelist_id: null,
        panelist_status: null,
        quantanite_email: null,
        recruiter_status: null,
        recruiter_status_updated_by: null,
        reminder_count: 0,
        reminder_sent_at: null,
        sent_at: null,
        status: 'Pending',
    },
    {
        candidate_mob_no: null,
        candidate_name: null,
        cv_link: 'https://drive.google.com/file/d/1QMjKcpaYSTjaJ5qCus-BNNPks77x-3vl/view',
        email: 'pratham0708@gmail.com',
        feedback: null,
        feedback_by: null,
        hiring_location: 'India',
        id: 5,
        interview_scheduled_at: null,
        interview_status: 'Pending',
        intro_video: 0,
        intro_video_2: 0,
        is_shortlisted: null,
        job_title: 'Frontend Developer',
        joining_date: null,
        offer_sent: 'Pending',
        offer_status: 'pending',
        onboard_email: null,
        panelist_id: null,
        panelist_status: null,
        quantanite_email: null,
        recruiter_status: null,
        recruiter_status_updated_by: null,
        reminder_count: 0,
        reminder_sent_at: null,
        sent_at: null,
        status: 'Pending',
    },
    {
        candidate_mob_no: null,
        candidate_name: null,
        cv_link: 'https://drive.google.com/file/d/1yFVUqVjwOVO85B7c2UrYwathEjlTIy46/view',
        email: 'saurabhkhairnar0@gmail.com',
        feedback: null,
        feedback_by: null,
        hiring_location: 'India',
        id: 6,
        interview_scheduled_at: null,
        interview_status: 'Pending',
        intro_video: 0,
        intro_video_2: 0,
        is_shortlisted: null,
        job_title: 'Frontend Developer',
        joining_date: null,
        offer_sent: 'Pending',
        offer_status: 'pending',
        onboard_email: null,
        panelist_id: null,
        panelist_status: null,
        quantanite_email: null,
        recruiter_status: null,
        recruiter_status_updated_by: null,
        reminder_count: 0,
        reminder_sent_at: null,
        sent_at: null,
        status: 'Pending',
    },
    {
        candidate_mob_no: null,
        candidate_name: null,
        cv_link: 'https://drive.google.com/file/d/1zl0ldftVyKulxdwUwDcPfycS6aTszj14/view',
        email: 'thepmsquare@gmail.com',
        feedback: null,
        feedback_by: null,
        hiring_location: 'India',
        id: 7,
        interview_scheduled_at: null,
        interview_status: 'Pending',
        intro_video: 0,
        intro_video_2: 0,
        is_shortlisted: null,
        job_title: 'Frontend Developer',
        joining_date: null,
        offer_sent: 'Pending',
        offer_status: 'pending',
        onboard_email: null,
        panelist_id: null,
        panelist_status: null,
        quantanite_email: null,
        recruiter_status: null,
        recruiter_status_updated_by: null,
        reminder_count: 0,
        reminder_sent_at: null,
        sent_at: null,
        status: 'Pending',
    },
    {
        candidate_mob_no: null,
        candidate_name: null,
        cv_link: 'https://drive.google.com/file/d/1dt0MqsNwlduLFmVOoqjcVSMFX11BJIUi/view',
        email: 'jhunjhunwalanakul@gmail.com',
        feedback: null,
        feedback_by: null,
        hiring_location: 'India',
        id: 8,
        interview_scheduled_at: null,
        interview_status: 'Pending',
        intro_video: 0,
        intro_video_2: 0,
        is_shortlisted: null,
        job_title: 'Frontend Developer',
        joining_date: null,
        offer_sent: 'Pending',
        offer_status: 'pending',
        onboard_email: null,
        panelist_id: null,
        panelist_status: null,
        quantanite_email: null,
        recruiter_status: null,
        recruiter_status_updated_by: null,
        reminder_count: 0,
        reminder_sent_at: null,
        sent_at: null,
        status: 'Pending',
    },
    {
        candidate_mob_no: '+91 9518572051',
        candidate_name: 'Suhani Agarwal',
        cv_link: 'https://drive.google.com/file/d/1WvuhrGbhTXJHaGFCdYbfr9dlsbKfLJz9/view',
        email: 'suhaniagarwal0330@gmail.com',
        feedback: null,
        feedback_by: null,
        hiring_location: 'India',
        id: 9,
        interview_scheduled_at: null,
        interview_status: 'Pending',
        intro_video: 0,
        intro_video_2: 0,
        is_shortlisted: null,
        job_title: 'AI Engineer',
        joining_date: null,
        offer_sent: 'Pending',
        offer_status: 'pending',
        onboard_email: null,
        panelist_id: null,
        panelist_status: null,
        quantanite_email: null,
        recruiter_status: null,
        recruiter_status_updated_by: null,
        reminder_count: 0,
        reminder_sent_at: null,
        sent_at: null,
        status: 'Pending',
    },
];
